// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'

export let DirectInstrumentTypeMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_INSTRUMENT_TYPE)
    this.superTypeId = 0
    this.typeId = 0
    this.typeName = null
    this.LanguageAliases = null;
    this.ExtendedFields = {};
}

DirectInstrumentTypeMessage.prototype = Object.create(DirectMessageBase.prototype)

Object.defineProperty(DirectInstrumentTypeMessage.prototype, 'SuperTypeId',
    {
        get: function () { return this.superTypeId },
        set: function (val) { this.superTypeId = val }
    }
)

Object.defineProperty(DirectInstrumentTypeMessage.prototype, 'TypeId',
    {
        get: function () { return this.typeId },
        set: function (val) { this.typeId = val }
    }
)

Object.defineProperty(DirectInstrumentTypeMessage.prototype, 'TypeName',
    {
        get: function () { return this.typeName },
        set: function (val) { this.typeName = val }
    }
)